import React from 'react';
import styled from 'styled-components';

import { FlexProps } from 'src/types';

export const StyledFlexContainer = styled.div<FlexProps & { disabled?: boolean }>`
    display: flex;
    width: auto;
    align-items: center;
    padding: 0;
    ${({ styles }) => styles};
    ${({ disabled }) => `
        cursor: ${disabled ? 'not-allowed' : 'initial'};
        
        * {
            cursor: ${disabled ? 'not-allowed' : 'initial'};
        }
    `};
`;

export const FlexContainer = ({
    children,
    styles,
    onClick,
    className,
    disabled = false,
}: FlexProps & { disabled?: boolean }): React.ReactElement => {
    return (
        <StyledFlexContainer
            className={className}
            onClick={onClick}
            styles={styles}
            disabled={disabled}
        >
            {children}
        </StyledFlexContainer>
    );
};
